import { html } from 'lit';
const StyleScribble =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.27 3.831a.75.75 0 0 1 .899-.562c6.615 1.527 12.547 4.893 15.306 7.15.361.296.66.6.846.919.195.335.305.77.109 1.21-.175.393-.523.617-.806.75-.3.142-.659.242-1.032.319-.75.155-1.715.25-2.739.336l-.756.063c-.817.066-1.667.135-2.514.23-2.243.249-4.035.569-5.13.952-.443.155-.694.295-.82.39.41.486 1.095.97 1.966 1.428.891.468 1.915.875 2.895 1.212a36 36 0 0 0 3.59 1.023l.056.012.014.003h.003a.75.75 0 0 1-.314 1.467L15 20l-.157.733h-.002l-.005-.001-.017-.004-.062-.014a28 28 0 0 1-1.072-.262c-.7-.183-1.656-.454-2.679-.805-1.02-.35-2.121-.787-3.105-1.303-.97-.51-1.89-1.13-2.487-1.876-.188-.235-.339-.535-.343-.888a1.34 1.34 0 0 1 .337-.889c.352-.414.94-.696 1.549-.909 1.267-.443 3.203-.777 5.46-1.027a88 88 0 0 1 2.573-.236l.737-.06c1.034-.088 1.913-.177 2.56-.31.288-.06.5-.123.645-.184a3 3 0 0 0-.407-.384c-2.587-2.117-8.31-5.377-14.694-6.85a.75.75 0 0 1-.562-.9" clip-rule="evenodd"/>
  </svg>
`;
export default StyleScribble;
